import { useEffect, useMemo, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";

// Components
import CategoryMobileItem from "components/molecules/CategoryMobileItem";

// Constants
import {
  CATEGORIES_ENUMS,
  POPULAR_CATEGORIES,
} from "constants/navigation/categories";

import "swiper/css";
import "./styles.sass";
import { useSelector } from "react-redux";
import * as gamesSelector from "redux/game/selectors";
import * as authSelectors from "redux/auth/selectors";
import { useGetCategoriesList } from "../../../queries/useGetCategoriesList";
import { useBreakpoint } from "../../../hooks/useBreakpoint";
import useTranslate from "../../../hooks/useTranslate";
import { gamesApi } from "../../../redux/game/api";
import { FavoritesResponseType } from "../../../types/Games";

type CategoryMobileProps = {
  isLocalizationLoaded: boolean;
  onSelect: (category: CATEGORIES_ENUMS | string) => void;
};

const CategoryMobile = (props: CategoryMobileProps) => {
  const { isLocalizationLoaded, onSelect } = props;
  const isAuthenticated = useSelector(authSelectors.isAuthenticated);
  const { isDesktop } = useBreakpoint();
  const category = useSelector(gamesSelector.category);
  const [swiperInstance, setSwiperInstance] = useState(null);
  const { categories, isLoading: categoriesLoading } = useGetCategoriesList(
    "leftSide",
    isDesktop ? 1 : 2,
  );
  const { data: favoriteData } = gamesApi.useFavoritesQuery();
  const favoriteGames =
    (favoriteData as FavoritesResponseType)?.favoriteGames || favoriteData;

  const t = useTranslate();
  const categoriesList = useMemo(() => {
    if (!categoriesLoading && categories.length) {
      return [...POPULAR_CATEGORIES, ...categories].filter((curCat) => {
        if (!isAuthenticated && curCat.name === CATEGORIES_ENUMS.FAVORITE) {
          return null;
        }
        if (
          isAuthenticated &&
          curCat.name === CATEGORIES_ENUMS.FAVORITE &&
          !favoriteGames?.length
        ) {
          return null;
        }
        if (isAuthenticated && curCat.name === CATEGORIES_ENUMS.SPORT) {
          return null;
        }
        if (curCat.name === CATEGORIES_ENUMS.POPULAR) {
          return null;
        }
        if (curCat.name === CATEGORIES_ENUMS.FORTUNE_WHEEL) {
          return false;
        }
        if (
          curCat.translatePlaceholder === "placeholder" ||
          !t(curCat.translatePlaceholder) ||
          curCat.translatePlaceholder === t(curCat.translatePlaceholder)
        ) {
          return null;
        }
        return curCat;
      });
    }
    return POPULAR_CATEGORIES;
  }, [categoriesLoading, categories, isAuthenticated, favoriteGames, t]);

  useEffect(() => {
    if (!swiperInstance || !category) {
      return;
    }
    const index = categoriesList.findIndex((c) => c.name === category);
    if (index > 0) {
      // @ts-ignore
      swiperInstance.slideTo(index);
    }
  }, [swiperInstance, category, categoriesList]);
  const handleSwiperInstance = (instance) => {
    setSwiperInstance(instance);
  };
  return (
    <div className="CategoryMobile">
      {isLocalizationLoaded && (
        <Swiper
          spaceBetween={8}
          slidesPerView="auto"
          freeMode
          onSwiper={handleSwiperInstance}
          normalizeSlideIndex
          centeredSlides
          centeredSlidesBounds
        >
          {categoriesList.map((cat, index) => {
            return (
              // eslint-disable-next-line react/no-array-index-key
              <SwiperSlide key={`${cat?.name}-${index}`}>
                <CategoryMobileItem
                  key={cat?.name}
                  item={cat}
                  // eslint-disable-next-line react/jsx-handler-names
                  onSelect={onSelect}
                  currentCategory={category}
                />
              </SwiperSlide>
            );
          })}
        </Swiper>
      )}
    </div>
  );
};

export default CategoryMobile;
